<div class="salehistoryorder" >

  <!-- Le titre de la colonne a disparu avec l'arrivée des onglets : l'onglet « Historique client »
       le porte déjà. -->
  @if (loading) {
    <div class="history-wait"><mat-spinner diameter="28"></mat-spinner><span>Chargement de l'historique du client…</span></div>
  } @else if (!displayOrders.length) {
    <div class="history-wait">@if (customer && customer.id) { Aucune commande antérieure pour ce client. } @else { Aucun client renseigné sur cette pièce. }</div>
  }
  <table style="width: 100%; table-layout:auto;" >
    @for(order of displayOrders ; track order.id; ){
      <!-- <div class="order"> -->

      <!-- <tr class="titledateorder" >Commande du  <span class="dateorder">{{  order.dates?.created | date:'dd/MM/yy hh:mm' }}</span></tr> -->
      <tr>
        <td class="titledateorder" colspan="7">
          <div style="display: flex; flex-direction: row; justify-content: space-between;">
            <div>
              Commande N°{{order.id}} du  <span class="dateorder">{{  $safeNavigationMigration(order.dates?.created) | date:'dd/MM/yy ' }}</span>
            </div>
            <div>
              <span class="state-badge badge" [ngClass]="getColor(order.state)" [class.valid]="order.state === SalesOrderState.QUOTE">
                {{ getLabel(order.state) }}
              </span>
            </div>
            <div>
              <a  	 [routerLink]="['/sales/quotation/' + order.id]" >Accès à la commande&nbsp;{{order.id}}</a>
            </div>
          </div>
        </td>
      </tr>

      <tr>
        <!-- <th class="col0">#</th> -->
        <th class="col1">Id</th>
        <!-- <th class="col1">Code barre</th> -->
        <th class="col2">Produit - Unité de Vente</th>
        <th class="col3">Qté</th>
        <!-- <th class="col3">Colisage</th>			 -->
        <th class="col4" title="Prix TTC d'un conditionnement, remise déduite">Px cond.</th>
        <th class="col5">Total</th>
        <!-- <th class="col6">TVA</th> -->
        <th >&nbsp;</th>
        <th>&nbsp;</th>
      </tr>

      @for( line of order.lines; track line.id; let i =$index ){
        <tr [class.first-line]="i === 0" [class.last-line]="i === order.lines.length - 1" [class.even-line]="i % 2 === 0">
          <!-- <td class="col0">
          {{ line.seq }}
        </td>				 -->
        <td class="col1">
          {{ line.product }}
        </td>
        <!-- <td class="col1">
        {{ line.ppv }}
      </td>				 -->
      <td class="col2"> <!-- name -->
        <!-- Nouvel onglet : la commande ouverte à côté de cet historique reste dans celui-ci (JP, 26/10). -->
        <a [routerLink]="['/sales/product', line.product]" target="_blank">{{ line.product_name }}</a> @if (line.packaging_name) {
        <span>-</span>
        } {{ line.packaging_name }}
      </td>
      <td class="col3">	<!-- Qty -->
        {{line.qty}}
      </td>
      <!-- <td class="col3" >
      {{ line.packaging_qty }}
    </td>					 -->
    @if (true) {
      <td class="col4" >	<!-- Prix net d'un conditionnement : une ligne servie l'est déjà -->
        {{ (line.unet_taxi ?? line.uprice_taxi) | fc }}
      </td>
    }
    <td class="col5">	<!-- Amount : montant TTC de la ligne tel qu'enregistré -->
      {{ line.net_taxi | fc }}
    </td>
    <!-- <td class="col6">
    {{ line.vat }}
  </td>				 -->
  <td class="col7 addline"  >
    <button class="custom-icon-button error dark addlinebutton"  type="button" aria-label="ajouter ce produit dans la commande" (click)="addproduct(line, line.qty)">
      <mat-icon>add</mat-icon>
    </button>
  </td>
  @if(order.lines.length >1 ){
    @if(i===0){
      <td [attr.rowspan]="order.lines.length" class="addgroup" >

        <button class="custom-icon-button error dark addgroupbutton"  type="button" aria-label="ajouter ce produit dans la commande" (click)="addAllproductOfOrder(order.lines)">
          <mat-icon>add</mat-icon>
        </button>
      </td>
    }
  } @else {
    <td class="col7">

    </td>
  }
</tr>
}

<tr class="trdivider"></tr>
<!-- </div> -->


}
</table>
</div>
